import {useMemo} from 'external/react'
import {clsx} from 'external/clsx'
import Loader from 'components/Loader'

const containerClasses = ['title', 'description', 'body'] as const;

type ContainerClassName = typeof containerClasses[number]

type Classes = {
	[Property in ContainerClassName]: string
}

export default function ContainerLayout(props) {

    const {title, description, children, loading} = props
    const classes = useMemo(()=> {
        return containerClasses.reduce((classes, key) => {
            classes[key] = clsx(key, props.className)
            return classes
        }, {} as Classes)
    }, [props.className])

	return (
		<div className='container_container'>
			<h2 className={classes.title}>{title}</h2>
			<p className={clsx(classes.description, {'d-none': !description})}>{description}</p>
			<Loader loading={loading} />
			<div className={classes.body}>
                {children}
			</div>
		</div>
	)
}